'use strict';

var toggleList = function(expandListToggleElement, expandListElement) {
    var hiddenElements = expandListElement.querySelectorAll('.expandListItem_hidden');
    var hiddenElementsCount = hiddenElements ? hiddenElements.length : null;

    expandListElement.classList.toggle('expandList_showHidden');

    if (!expandListElement.classList.contains('expandList_showHidden')) {
        expandListToggleElement.innerHTML = hiddenElementsCount + ' weitere anzeigen';
    } else {
        expandListToggleElement.innerHTML = 'weniger anzeigen';
    }
};

var expandListElements = document.querySelectorAll('.expandList');

if (expandListElements) {
    expandListElements.forEach(function(expandListElement) {
        var toggleClassName = 'expandList_Toggle';
        var expandListToggle = expandListElement.querySelector('.' + toggleClassName);

        if (!expandListToggle) {
            var nextPossibleToggleElem = expandListElement.nextElementSibling;
            var isNextPossibleToggleElem =
                nextPossibleToggleElem && nextPossibleToggleElem.classList.contains(toggleClassName);

            expandListToggle = isNextPossibleToggleElem ? nextPossibleToggleElem : null;
        }

        if (expandListToggle) {
            expandListToggle.addEventListener('click', function() {
                toggleList(this, expandListElement);
            });
        }
    });
}
